import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {Store} from '@ngrx/store';
import {AppState, IGlobalContext, selectGlobalContext} from '@store/app.states';
import {getTangoCardsTransactions} from '@app/4dm1n/tango-cards/_store/tango-cards.actions';
import {ITangoCardEvent, TangoCardsService} from '@app/4dm1n/tango-cards/_store/tango-cards.service';
import {selectSearchingState} from '@app/4dm1n/tango-cards/_store/tango-cards.selectors';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-search-cards',
    templateUrl: './search-cards.component.html',
    styleUrls: ['./search-cards.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SearchCardsComponent extends OnDestroyMixin implements OnInit, OnDestroy {

  globalContext$: Observable<IGlobalContext> = this.store.select(selectGlobalContext).pipe(untilComponentDestroyed(this));

  batchUserSelectedEmails = new UntypedFormControl('');
  emailSelected: string[] = [];

  localSearchResult: ITangoCardEvent[] = [];
  isSearching = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>,
    private tangoCardService: TangoCardsService,
  ) {
    super();
  }

  ngOnDestroy() {
    this.tangoCardService.clearDatas();
    super.ngOnDestroy();
  }

  ngOnInit(): void {

    this.globalContext$.subscribe((data) => {
      this.cdr.markForCheck();
    });

    this.store.select(selectSearchingState).pipe(untilComponentDestroyed(this)).subscribe((data) => {

      this.isSearching = data.isSearching;

      if (!data.isSearching) {
        this.localSearchResult = this.tangoCardService.getTangoSearchResult();
      }

      this.cdr.markForCheck();
    });

    this.batchUserSelectedEmails.valueChanges.subscribe(() => {
      this.emailSelected =
        this.batchUserSelectedEmails.value
          .trim()
          .split(' ')
          .join(',')
          .split(/\r?\n/)
          .join(',')
          .split(';')
          .join(',')
          .split(',')
          .map((el) => el.replace(/'/g, '').replace(' ', ''))
          .filter((el) => {
            if (el.length > 0) {
              return el;
            }
          }) || [];


    });

  }

  doSearch(): void {
    this.store.dispatch(getTangoCardsTransactions({emails: this.emailSelected}));
  }


}
